import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const Toast = ({ message, type = 'success', onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <AnimatePresence>
      <motion.div
        style={{
          position: 'fixed',
          bottom: '30px',
          right: '30px',
          background: 'white',
          padding: '14px 24px',
          borderRadius: '12px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
          zIndex: 10001,
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          borderLeft: `4px solid ${type === 'success' ? '#10b981' : '#ef4444'}`
        }}
        initial={{ x: '100%', opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        exit={{ x: '100%', opacity: 0 }}
        transition={{ duration: 0.3 }}
      >
        <i className={`fas ${type === 'success' ? 'fa-check-circle' : 'fa-exclamation-circle'}`} style={{ color: type === 'success' ? '#10b981' : '#ef4444' }}></i>
        <span>{message}</span>
      </motion.div>
    </AnimatePresence>
  );
};

export default Toast;